import { render, staticRenderFns } from "./TabReceived.vue?vue&type=template&id=9b518408"
import script from "./TabReceived.vue?vue&type=script&lang=js"
export * from "./TabReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports